import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingDialogComponent } from '@app/shared/dialog/loading-dialog/loading-dialog.component';
import { SelectLangComponent } from '@app/shared/dialog/select-lang/select-lang.component';
import { ConfirmDialogComponent } from '@app/shared/dialog/confirm-dialog/confirm-dialog.component';
import { DialogService } from '@app/shared/dialog/dialog.service';
import { SharedModule } from '@app/shared/shared.module';

import { FormDialogComponent } from '@app/shared/dialog/form-dialog/form-dialog.component';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { PicklistEditorDialogComponent } from '@app/shared/dialog/picklist-editor-dialog/picklist-editor-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,

        ConfirmDialogComponent,
        LoadingDialogComponent,
        SelectLangComponent,
        FormDialogComponent,
        PicklistEditorDialogComponent
    ],
    providers: [
        DialogService,
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true, direction: 'ltr' } }
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    exports: [
        ConfirmDialogComponent,
        LoadingDialogComponent,
        SelectLangComponent,
        FormDialogComponent,
    ]
})
export class DialogModule { }
